export const Roles = {
  Crosspoint: "CrossPoint",
  CrosspointAdmin: "CrossPointAdmin",
  CrosspointSubscription: "CrosspointSubscription",
  CrosspointPricelistManagement: "CrossPointPricelistManagement",
  Dealer: "Dealer",
  DealerAdmin: "DealerAdmin",
  DealerSubscription: "DealerSubscription",
  DealerPricelistManagement: "DealerPricelistManagement",
  Retailer: "Retailer",
  RetailerAdmin: "RetailerAdmin",
  RetailerSubscription: "RetailerSubscription"
};